<template>
    <div class="wrapper presentation-page">
        <div class="page-header clear-filter">
            <div class="rellax-header rellax-header-sky">
                <parallax class="page-header-image"
                          style="background-image: url('img/presentation-page/nuk-pro-back-sky-black.jpg')">

<!--              style="height:100%; background-image: url('img/forswitch/homePage3.jpg')">-->

              </parallax>
            </div>
            <div class="rellax-header rellax-header-buildings" data-rellax-speed="0">
                <parallax class="page-header-image page-header-city"
                          style="background-image: url('img/presentation-page/nuk-pro-buildings-black.png')">
                <!--                          style="background-image: url('img/forswitch/homePage4.png')">-->
<!--                     style="background-image: url('img/forswitch/forswitch-building-software.jpg')">-->

              </parallax>
            </div>
            <div class="rellax-text-container rellax-text">
                <h1 class="h1-seo" data-rellax-speed="-2">For Switch</h1>
<!--                <div class="pro">PRO</div>-->
            </div>
            <h3 class="h3-description rellax-text" data-rellax-speed="-1">
              Building your own sofware solution
              <br>
              is easier than you think.
            </h3>
<!--            <h6 class="category category-absolute rellax-text" data-rellax-speed="-2">-->
<!--                <parallax>-->
<!--                    Designed by-->
<!--                    <a href="https:///invisionapp.com/" target="_blank">-->
<!--                        <img v-lazy="'img/invision-white-slim.png'" class="invision-logo" alt=""/>-->
<!--                    </a>. Coded by-->
<!--                    <a href="https://www.creative-tim.com" target="_blank">-->
<!--                        <img v-lazy="'img/creative-tim-white-slim2.png'" class="creative-tim-logo" alt=""/>-->
<!--                    </a>.-->
<!--                </parallax>-->
<!--            </h6>-->
        </div>
      <div id="about" class="section section-company-info" data-background-color="black">
        <div class="container">
          <div class="row">
            <div class="col-md-8 ml-auto mr-auto">
              <h2 class="text-center title">About us
              </h2>
              <h5 class="text-center description">
                We are an Agile software development company with over 20 years of experience building a wide
                range of software using a variety of technologies.
                <br>
                <br>
                From mobile to desktop to web, we have the
                experience and expertise to build virtually any application. We thrive on building custom quality
                software at a competitive price.
              </h5>
            </div>
          </div>
        </div>
      </div>

      <div id="services" class="section cd-section">
        <div class="blogs-1" id="blogs-1">
          <div class="container">
            <div class="row">
              <div class="col-md-10 ml-auto mr-auto">
                <h2 class="title">Services</h2>
                <br />
                <card type="blog" plain>
                  <div class="row" slot="image">
                    <div class="col-md-5">
                      <img class="img img-raised rounded" src="img/project8.jpg" />
                    </div>
                    <div class="col-md-7">
                      <h3 class="card-title">
                        Enterprise Software Solutions
                      </h3>
                      <p class="card-description" style="color:black;">
                        You know your business’s requirements better than anyone and sometimes there simply is
                        no off-the-shelf software that fits the bill. If you have exhausted your search,
                        it may be time to consider developing your own software product.
                        <br>
                        <br>
                        We have built many custom software solutions for our clients. Java, C#, C++, JavaScript,
                        and HTML are but a tiny fraction of the technologies we employ to bring your software to life.
                        <br>
                        <br>
                        <a href="#contact" style="color: #C10000;"><b>Contact us</b></a> today for inquiries and free estimates!
                      </p>
                    </div>
                  </div>
                </card>
                <card type="blog" plain>
                  <div class="row">
                    <div class="col-md-7">
                      <h3 class="card-title">
                        <a href="#pablo">Agile Coaching</a>
                      </h3>
                      <p class="card-description" style="color: black">
                        Although originating in software development, Agile is now widespread across various
                        industries. With many experienced Scrum Masters on our team, we can help you optimize
                        your workload and boost productivity.
                        <br>
                        <br>
                        Furthermore, if you also happen to operate in the software development industry,
                        we can help your development team transition into proven Agile practices such as
                        Extreme Programming and Test Driven Development.
                        <br>
                        <br>
                        <a href="#contact" style="color: #C10000;"><b>Contact us</b></a> today for inquiries and free estimates!
                      </p>
                    </div>
                    <div class="col-md-5">
                      <div class="card-image">
                        <img class="img img-raised rounded
                                " src="img/examples/card-blog6.jpg" />
                      </div>
                    </div>
                  </div>
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section" data-background-color="black">
        <div class="about-description text-center">
          <div class="features-3">
            <div class="container">
              <div class="row">
                <div class="col-md-8 mr-auto ml-auto">
                  <h2 class="title">Simpler. Smarter. Faster.</h2>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="info info-hover">
                    <div class="icon icon-success icon-circle">
                      <i class="now-ui-icons objects_globe"></i>
                    </div>
                    <h4 class="info-title">Increase Customer Base</h4>
                    <!--                    <p class="description" style="color: black">-->
                    <!--                      A good PR Firm listens to the marketplace and creates the relationships-->
                    <!--                      that matter. We can project you positively into these relationships!-->
                    <!--                    </p>-->
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="info info-hover">
                    <div class="icon icon-info icon-circle">
                      <i class="now-ui-icons business_money-coins"></i>
                    </div>
                    <h4 class="info-title">Added Value For Your Firm</h4>
                    <!--                    <p class="description" style="color: black">-->
                    <!--                      Protect or enhance your reputation through the media & publicize the best-->
                    <!--                      features of your services or products.-->
                    <!--                    </p>-->
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="info info-hover">
                    <div class="icon icon-primary icon-circle">
                      <i class="now-ui-icons tech_watch-time"></i>
                    </div>
                    <h4 class="info-title">Save Time</h4>
                    <!--                    <p class="description" style="color: black">-->
                    <!--                      Our goal is about influencing, engaging, and building relationships with key stakeholders-->
                    <!--                      to shape our ecosystem at its maximum market share.-->
                    <!--                    </p>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="contact" class="section wrapper contact-page main" data-background-color="gray">
        <div class="contact-content">
          <div class="container">
            <div class="row">
              <div class="col-md-12 ml-auto mr-auto">
                <h2 class="title">Want to work with us?</h2>
                <p class="description" style="color: black">
                  Divide details about your product or agency work into parts. Write a few lines about
                  each one and contact us about any further collaboration. We will get back to you in
                  a couple of hours.
                  <br>
                  <br>
                </p>
                <form role="form" id="contact-form" method="post">
                  <label>*Your name</label>
                  <fg-input
                      placeholder="Your Full Name..."
                      v-model="form.fullName"
                      addon-left-icon="now-ui-icons users_circle-08"
                      input-classes="company-contact-input">
                  </fg-input>

                  <label>*Email address</label>
                  <fg-input
                      placeholder="Email Here..."
                      v-model="form.email"
                      addon-left-icon="now-ui-icons ui-1_email-85"
                      input-classes="company-contact-input">
                  </fg-input>
                  <slot name="helpBlock" v-if="!isValidEmail(form.email)">
                    <div class="text-danger invalid-feedback mt-2" style="display: block;">
                      Invalid email format.
                    </div>
                  </slot>

                  <label>Phone</label>
                  <fg-input
                      placeholder="Number Here..."
                      v-model="form.phone"
                      addon-left-icon="now-ui-icons tech_mobile"
                      input-classes="company-contact-input">
                  </fg-input>
                  <slot name="helpBlock" v-if="!isValidPhone(form.phone)">
                    <div class="text-danger invalid-feedback mt-2" style="display: block;">
                      Invalid phone number format.
                    </div>
                  </slot>

                  <div class="form-group">
                    <label>*Your messages</label>
                    <textarea v-model="form.message"
                              name="message"
                              class="form-control company-contact-input"
                              id="message"
                              rows="6"
                              style="background-color: white">
                    </textarea>
                  </div>
                  <slot name="helpBlock" v-if="!isValidMessage(form.message)">
                    <div class="text-danger invalid-feedback mt-2" style="display: block;">
                      Message has to be 500 characters or less.
                    </div>
                  </slot>

                  <div class="submit text-center" @click="sendEmail">
                    <n-button type="forswitch" round >Contact Us</n-button>
                    <slot name="helpBlock" v-if="!isValidForm()">
                      <div class=" invalid-feedback mt-2" style="display: block; color: #C10000">
                        *: All fields are required to send an email.
                      </div>
                    </slot>

                    <div v-if="sent">
                      <alert type="success" dismissible>
                        <strong>Message sent!</strong> We will get back to you within 24h.
                      </alert>
                    </div>

                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="footer footer-white">
        <div class="container">
          <a class="footer-brand" href="/">
            <div style="width: 100px; margin: auto;">
              <img src="img/forswitch/logo-h-full-forswitch.png" alt="ForSwitch logo">
            </div>
          </a>
          <ul class="pull-center">
            <li>
              <a href="#about" class="nav-link">
                about
              </a>
            </li>
            <li>
              <a href="#services" class="nav-link">
                services
              </a>
            </li>
            <li>
              <a href="#contact" class="nav-link">
                contact
              </a>
            </li>
          </ul>
          <ul class="social-buttons pull-right">
            <li>
              <a href="#contact" target="_blank"
                 class="btn btn-icon btn-neutral btn-google">
<!--                <i class="fab fa-google-plus"></i>-->
              </a>
            </li>
          </ul>
        </div>
      </footer>
    </div>
</template>

<script>
import { Card, InfoSection, FormGroupInput, Button, Alert } from '@/components';
import { Carousel, CarouselItem, Tooltip } from 'element-ui'
// import { ValidationProvider, extend } from 'vee-validate';
// import { required } from 'vee-validate/dist/rules';
const querystring = require("querystring");

  export default {
    name: 'home',
    bodyClass: 'presentation-page',
    components: {
      Card,
      InfoSection,
      [Carousel.name]: Carousel,
      [CarouselItem.name]: CarouselItem,
      [Tooltip.name]: Tooltip,
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput,
      // ValidationProvider
    },
    data() {
      return {
        form: {
          fullName: '',
          email: '',
          phone: '',
          message: ''
        },
        value: '',
        sent: false
      }
    },
    methods: {
      sendEmail(e) {
        // debugger
        console.log('Name is: ' + this.form.fullName)
        console.log('email is: ' + this.form.email)
        console.log('phone is: ' + this.form.phone)
        console.log('message is: ' + this.form.message)
        if(this.isValidForm)
        {
          e.preventDefault();
          this.$axios
              .post(
                  "https://forswitch.com/mail.php",
                  querystring.stringify(this.form)
              )
              .then(res => {
                this.sent = true;
              });
        }
        // debugger
        // console.log('Name is: ' + this.form.fullName)
        // console.log('email is: ' + this.form.email)
        // console.log('phone is: ' + this.form.phone)
        // console.log('message is: ' + this.form.message)
      },
      isValidEmail(email) {
        const re = /^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      },
      isValidPhone(phone) {
        const re = /^$|^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
        return re.test(String(phone).toLocaleLowerCase())
      },
      isValidMessage(message) {
        const re = /^(.{0,100})$/;
        return re.test(String(message).toLocaleLowerCase())
      },
      isValidForm() {
        // if(this.form.email && this.form.fullName && this.form.message && this.form.phone) {
        if(this.isValidEmail(this.form.email)
            && this.isValidMessage(this.form.message)
            && this.isValidEmail(this.form.phone)
            && this.form.fullName != ''
            && this.form.email    != ''
            && this.form.message  != '' ) {
          return true
        }
        else {
          return false
        }
      }
    }
  }
</script>

<style scoped lang="scss">
    .github-buttons {
        display: flex;
        align-content: center;
    }
</style>
